import React__default from 'react';
import PT from 'prop-types';
import { T as TouchLinkButton, a as TouchLinkAnchor } from '../TouchLink.styles-Bk40_8ua.js';
import { I as InlineTouchLinkBody } from './InlineTouchLinkBody-B2rGa8u5.js';

const TouchLink = ({
  children,
  href,
  onClick
}) => {
  if (onClick) {
    return /*#__PURE__*/React__default.createElement(TouchLinkButton, {
      onClick: onClick
    }, /*#__PURE__*/React__default.createElement(InlineTouchLinkBody, null, children));
  }
  return /*#__PURE__*/React__default.createElement(TouchLinkAnchor, {
    href: href
  }, /*#__PURE__*/React__default.createElement(InlineTouchLinkBody, null, children));
};
TouchLink.propTypes = {
  /**
   * Use to add a link to InlineTouchLink.
   */
  href: PT.string,
  /**
   * Use to add a button to TouchLink.
   */
  onClick: PT.func
};
TouchLink.defaultProps = {
  href: undefined,
  onClick: undefined
};
TouchLink.displayName = 'InlineTouchLink';

export { TouchLink as T };
//# sourceMappingURL=InlineTouchLink-W1I4SA_T.js.map
